import Section from "@/components/Section";
import { Box, Container, Typography, useTheme } from "@mui/material";
import icon_url from "@/assets/icons/api-integration/api.svg";
import thumbnail_url from "@/assets/images/api-integration/api_thumbnail.png";
import BenefitsSection from "./components/BenefitsSection";
import QuestionsSection from "./components/QuestionsSection";
import FeaturedIntegrationsSection from "./components/FeaturedIntegrationsSection";
import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import { getBreadcrumbRoute } from "@/utils/getBreadcrumbRoute";
import { useLocation } from "react-router";
import AnimatedImage from "@/components/UI-Kit/AnimatedImage";

const APIIntegration = () => {
  const theme = useTheme();
  const location = useLocation();

  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, md: 0, lg: 0 } }}>
        <Breadcrumb options={getBreadcrumbRoute(location)} />
      </Container>
      <Section pt={{ xs: 0, md: 17.5 }} pb={{ xs: 0, md: 17.5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: { md: "space-between" },
          }}
        >
          <Box
            sx={{
              marginBottom: { xs: "40px", md: "0px" },
              alignSelf: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="h1"
              color={theme.palette.grey[800]}
              sx={{
                maxWidth: "795px",
                marginBottom: { xs: "16px", md: "24px" },
              }}
            >
              Connect, Integrate, Engage!
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color={theme.palette.grey[600]}
              sx={{
                maxWidth: "630px",
              }}
            >
              Our custom APIs make connecting Trackmate data with your existing 
              systems easy. View data from a single source of truth and improve the
              value of your business intelligence.
            </Typography>
          </Box>
          <AnimatedImage
            sx={{
              width: "100%",
              maxWidth: { xs: "375px", md: "640px" },
              img: {
                width: "100%",
                height: "auto",
              },
            }}
            thumbnailUrl={thumbnail_url}
            mainUrl={icon_url}
            alt="api integration"
          />
        </Box>
      </Section>
      <BenefitsSection />
      <FeaturedIntegrationsSection />
      <QuestionsSection />
    </>
  );
};

export default APIIntegration;
